import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { colors } from "../../theme";
import { groupSlotsForCompact, lineupSectionId } from "../../utils/sportField";
import FormationLineupRow from "./FormationLineupRow";

const FormationLineupCard = ({
  sport,
  slots = [],
  players,
  rosterId,
  editable = false,
  onSelect,
  onClear,
}) => {
  const groups = groupSlotsForCompact(sport, slots);
  const jumpGroups = groups.filter((group) => group.label);

  return (
    <Box>
      <Typography
        variant="overline"
        color="text.secondary"
        sx={{ letterSpacing: "0.16em" }}
      >
        The lineup
      </Typography>
      <Typography variant="h5" fontWeight={800} sx={{ mt: 0.25 }}>
        {sport === "nfl" ? "Offense, defense, and special teams" : "Starting five"}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mt: 0.5, mb: jumpGroups.length > 1 ? 1.5 : 2, maxWidth: 520 }}
      >
        {editable
          ? "Tap a row or a spot on the field."
          : "How they’d take the field."}
      </Typography>
      {jumpGroups.length > 1 && (
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 2 }}>
          {jumpGroups.map((group) => (
            <Chip
              key={group.id}
              component="a"
              href={`#${lineupSectionId(group.id, rosterId)}`}
              label={group.label}
              clickable
              variant="outlined"
              size="small"
            />
          ))}
        </Box>
      )}
      {groups.map((group) => (
        <Box
          key={group.id}
          id={lineupSectionId(group.id, rosterId)}
          sx={{ mb: 2, scrollMarginTop: 96 }}
        >
          {group.label && (
            <Typography
              variant="overline"
              color="text.secondary"
              sx={{ letterSpacing: "0.12em" }}
            >
              {group.label}
            </Typography>
          )}
          <Box
            sx={{
              borderRadius: 3,
              border: `1px solid ${colors.border}`,
              bgcolor: "#10140f",
              overflow: "hidden",
              mt: group.label ? 1 : 0,
            }}
          >
            {group.slots.map((slot) => (
              <FormationLineupRow
                key={slot.id}
                slot={slot}
                player={players?.[slot.id]}
                sport={sport}
                editable={editable}
                onSelect={onSelect}
                onClear={onClear}
              />
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default FormationLineupCard;
